import { EventMembersTab } from "./EventMembersTab";

export default EventMembersTab;
